<template>
    <div class="get-pieces-dialog">
        <BaseDialog button="确定" v-on="$listeners">
            <div slot="title" class="get-pieces-head">
                <p>成功获得</p>
                <img class="get-pieces-head-img" src="https://oss01.dayou.art/interior-subscribe-img-head.png" alt="大有预约">
            </div>

            <div slot="content" class="pieces-list">
                <p class="pieces" v-for="(item, index) in formatList" :key="index">
                    “{{item.piece_name}}”号碎片 x{{item.num}}
                </p>
            </div>
        </BaseDialog>
    </div>
</template>

<script>
import BaseDialog from '@/components/dialog/baseDialog/baseDialog'
export default {
    components: {
        BaseDialog,
    },
    props: {
        // 传入的碎片列表
        list: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        // 格式化列表
        formatList () {
            const list = []
            const map = {}

            this.list.forEach(item => {
                const key = item.piece_name
                map[key] = map[key] ? map[key] + 1 : 1
            })
            for (let key in map) list.push({ piece_name: key, num: map[key] })
            return list
        }
    },
    methods: {},
}
</script>

<style lang="less" scoped>
@import "./get_pieces.less";
</style>